/**
 * NameSpace qui gere la pagination des avis client pour un produit.
 */
var productReview = {

    $reviewDiv: $('#reviews'),

    /** Nombre d'avis afficher par page **/
    nbPerPage: null,

    nbPages: null,

    /**
     * Methode qui initialise la pagination des avis et la gestion des jugements de ces avis.
     */
    init: function () {
        var $this = this;


        this.nbPerPage = $this.$reviewDiv.find('.pager').data('nb-per-page');
        if (!this.nbPerPage) {
            this.nbPerPage = 3;
        }


        /** Regroupe les avis des clients par groupe de trois pour gerer la pagination **/
        $this.$reviewDiv.find('.line-review').each(function (i) {
            if (i % $this.nbPerPage == 0) {
                var nbPage = Math.ceil(i / $this.nbPerPage) + 1;
                var $element = $('<div class="review-page" data-page-nb="' + nbPage + '"></div>');
                $(this).nextAll().addBack().slice(0, $this.nbPerPage).wrapAll($element);

                // Hack IE pour afficher les SVG
                $element = $('.review-list').find('.review-page[data-page-nb="' + nbPage + '"]');
                $element.html($element.html());
            }
        });

        $this.nbPages = $('.review-list').find('.review-page').length;

        /** Lance les methodes qui gere la pagination **/
        $this.$reviewDiv.find('.pager').on('click', '.btn-prev:not(.disabled), .btn-next:not(.disabled)', function (e) {
            e.preventDefault();
            $this.displayPage($(this).data('page-nb'));
            return false;
        });

        // var nbPage = Math.ceil($this.$reviewDiv.find('.line-review').length / $this.nbPerPage);
        // $this.generatePageButton(nbPage);
        $this.displayPage(1);
    },


    /**
     * Methode qui creer les liens/boutons de pagination pour les avis.
     */
    generatePageButton: function (nbPage) {
        var $this = this;
        if ($this.$reviewDiv.find('.review-list a').length == 0) {
            for (var page = 1; page <= nbPage; page++) {
                var $bouton = $('<a href="#" class="button_avis" title="Page ' + page + '" data-page-nb="' + page + '">' + page + '</a>');
                $this.$reviewDiv.find('.review-list').append($bouton);
            }
        }

    },


    /**
     * Methode qui affiche une page d'avis et qui cache toutes les autres pages.
     */
    displayPage: function (page) {
        var $this = this;
        $this.$reviewDiv.find('.review-list div.review-page').hide();
        $this.$reviewDiv.find('.review-list div.review-page[data-page-nb="' + page + '"]').show();

        // $this.$reviewDiv.find('.review-list a').removeClass('selected_button_avis').addClass('button_avis');
        // $this.$reviewDiv.find('.review-list a[data-page-nb="' + page + '"]').removeClass('button_avis').addClass('selected_button_avis');

        var $pager = $this.$reviewDiv.find('.pager');

        $pager.find('.current-page').text(page);

        if ($pager.length > 0) {
            $pager.find('.btn-prev').data('page-nb', page - 1).toggleClass('disabled', page <= 1);
            $pager.find('.btn-next').data('page-nb', page + 1).toggleClass('disabled', page >= $this.nbPages);
        }
    },

};


(function ($) {
    productReview.init();
})(jQuery);